<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown" class="settings-icon">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"> </i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <div :style="displaySidebarBkcolor">
          <li class="header-title">Sidebar Background</li>
          <li class="adjustments-line">
            <a class="switch-trigger background-color">
              <div class="badge-colors text-center">
                <span
                  v-for="item in sidebarColors"
                  :key="item.color"
                  class="badge filter"
                  :class="[`badge-${item.color}`, { active: item.active }]"
                  :data-color="item.color"
                  @click="changeSidebarBackground(item);"
                ></span>
              </div>
              <div class="clearfix"></div>
            </a>
          </li>
        </div>

        <li class="header-title">Sidebar Mini</li>
        <li class="adjustments-line">
          <div class="togglebutton switch-sidebar-mini">
            <span class="label-switch">OFF</span>
            <base-switch
              v-model="sidebarMini"
              @input="minimizeSidebar"
            ></base-switch>
            <span class="label-switch label-right">ON</span>
          </div>

          <div class="togglebutton switch-change-color mt-3">
            <span class="label-switch">LIGHT MODE</span>
            <base-switch v-model="darkMode" @input="toggleMode"></base-switch>
            <span class="label-switch label-right">DARK MODE</span>
          </div>
        </li>

        <li class="button-container mt-4">
          <div :style="linksDisplay">
            <a
              href="https://demos.creative-tim.com/vue-black-dashboard-pro/documentation"
              target="_blank"
              rel="noopener"
              class="btn btn-default btn-block btn-round"
            >
              Documentation
            </a>
            <a
              href="https://creative-tim.com/product/vue-black-dashboard-pro"
              target="_blank"
              rel="noopener"
              class="btn btn-primary btn-block btn-round"
            >
              Buy for $59
            </a>
            <a
              href="https://demos.creative-tim.com/vue-black-dashboard"
              target="_blank"
              rel="noopener"
              class="btn btn-info btn-block btn-round"
            >
              Free Version
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { BaseSwitch } from 'src/components';
  import { isDarkMode } from 'src/modules/utils';

  export default {
    name: 'sidebar-share',
    components: {
      BaseSwitch
    },
    props: {
      backgroundColor: String,
      includeLinks: {
        type: Boolean,
        default: false,
      },
      includeSidebarBkcolorOptions: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        sidebarMini: true,
        darkMode: isDarkMode(),
        isOpen: false,
        sidebarColors: [
          { color: 'primary', active: false, value: 'primary' },
          { color: 'vue', active: true, value: 'vue' },
          { color: 'info', active: false, value: 'blue' },
          { color: 'success', active: false, value: 'green' },
          { color: 'warning', active: false, value: 'orange' },
          { color: 'danger', active: false, value: 'red' }
        ]
      };
    },
    computed: {
      linksDisplay() {
        return this.includeLinks ? "display: block;" : "display: none;";
      },
      displaySidebarBkcolor() {
        return this.includeSidebarBkcolorOptions ? "display: block;" : "display: none;";
      },
    },
    methods: {
      toggleDropDown() {
        this.isOpen = !this.isOpen;
      },
      closeDropDown() {
        this.isOpen = false;
      },
      toggleList(list, itemToActivate) {
        list.forEach(listItem => {
          listItem.active = false;
        });
        itemToActivate.active = true;
      },
      changeSidebarBackground(item) {
        this.$emit('update:backgroundColor', item.value);
        this.toggleList(this.sidebarColors, item);
      },
      toggleMode(type) {
        let docClasses = document.body.classList;
        let darkmode = false;
        if (type) {
          docClasses.remove('white-content');
          darkmode = true;
        } else {
          docClasses.add('white-content');
        }

        this.$emit('darkModeToggled', darkmode);
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize();
      }
    }
  };
</script>
<style scoped lang="scss">
  @import '~@/assets/sass/dashboard/custom/variables';

  .settings-icon {
    cursor: pointer;
  }

  .badge-vue {
    background-color: $vue;
  }
</style>
